import { EMPTY_FUNCTION } from '../../../constants/common'
import { SearchTypeInput } from '../SearchTypeInput'

import {
  SEARCH_ARCHIVED_INPUT_ITEM_ACTIVE,
  SEARCH_ARCHIVED_INPUT_ITEM_ARCHIVED,
  SEARCH_ARCHIVED_INPUT_ITEMS,
} from './SearchArchivedInput.constants'

/**
 * @typedef {object} SearchArchivedInputProps
 *
 * @property {string} [className]
 *
 * @property {boolean} [value]
 *
 * @property {(archived: boolean) => void} [onChange]
 */

/**
 * @param {SearchArchivedInputProps} props
 */
function SearchArchivedInput({
  className,
  value = false,
  onChange = EMPTY_FUNCTION,
}) {
  const selectedItem = value
    ? SEARCH_ARCHIVED_INPUT_ITEM_ARCHIVED
    : SEARCH_ARCHIVED_INPUT_ITEM_ACTIVE

  function handleChange(item) {
    onChange(item.archived)
  }

  return (
    <SearchTypeInput
      className={className}
      items={SEARCH_ARCHIVED_INPUT_ITEMS}
      value={selectedItem}
      onChange={handleChange}
    />
  )
}

export default SearchArchivedInput
